import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component '" + name + "' was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`During the lean season – the period between the harvests when food reserves run low – many people are not only confronted with dwindling supplies, but also face an increased risk of inter-community conflict, as hunger can often drive insecurity. In 2019, funding from the EU allowed WFP to provide `}<a parentName="p" {...{
        "href": "https://twitter.com/WFP_Europe/status/1233740083121074186"
      }}>{`food and nutritional assistance`}</a>{` during this tough time, meeting the immediate needs of the most vulnerable and in doing so reducing tensions between farmers and pastoralists.`}</p>
    <p>{`WFP further contributed to peacebuilding initiatives in the country through the rehabilitation of land which the government could then distribute among displaced and local households living around Lake Chad. With the help of donors like the EU, WFP rehabilitated 502 acres that benefitted more than 5,300 people, significantly reducing the risk of conflict over land in this area. `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      